import styled from 'styled-components'
import { SingleSelect as DdsSingleSelect } from '@diversioteam/diversio-ds'

export const SingleSelect = styled(DdsSingleSelect)`
    button {
        border-bottom: none;
        margin-top: 6px;
    }
` as typeof DdsSingleSelect
